// faceTrackIndicatorState — what the face-capture viewport pill says (ENG-1107).
// Pure decisions, the sibling of headTrackIndicatorState.js. The pill exists
// only while a Face Tracker node is PLUGGED into the face graph — that is the
// user's intent, so unlike ENG-981's rail-armed camera there is no separate
// "start" surface: `idle` (nothing plugged) renders nothing, `blocked`/`error`
// render the reason plus Retry (the node card offers the same Retry), and
// `tracking` carries REC.

export const UNKNOWN_ERROR_TEXT = 'unknown error'

function mmss(ms) {
  const s = Math.floor((ms || 0) / 1000)
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}

/**
 * @returns {{visible: boolean, tone: string|null, label: string|null, dot: 'solid'|'hollow'|null,
 *            actions: Array<{id: 'rec'|'stoprec'|'retry', label: string}>}}
 */
export function resolveFaceTrackIndicator({ state, faceSeen = false, errorMessage = null, recording = false, elapsedMs = 0, frameCount = 0 } = {}) {
  switch (state) {
    case 'starting':
      return { visible: true, tone: 'neutral', label: 'Face Tracker · starting camera…', dot: null, actions: [] }
    case 'tracking':
      if (recording) {
        return {
          visible: true, tone: 'danger',
          label: `REC ${mmss(elapsedMs)} · ${frameCount} frames`,
          dot: faceSeen ? 'solid' : 'hollow',
          actions: [{ id: 'stoprec', label: '■ Stop' }],
        }
      }
      return {
        visible: true, tone: 'tracking',
        label: faceSeen ? 'Face Tracker · camera on' : 'Face Tracker · no face',
        dot: faceSeen ? 'solid' : 'hollow',
        actions: [{ id: 'rec', label: '● REC' }],
      }
    case 'blocked':
      return { visible: true, tone: 'danger', label: 'Face Tracker · camera blocked — allow camera access for this site', dot: null, actions: [{ id: 'retry', label: 'Retry' }] }
    case 'error':
      return { visible: true, tone: 'danger', label: `Face Tracker · camera failed: ${errorMessage || UNKNOWN_ERROR_TEXT}`, dot: null, actions: [{ id: 'retry', label: 'Retry' }] }
    default:
      return { visible: false, tone: null, label: null, dot: null, actions: [] }
  }
}
